import * as firebase from 'firebase';
import 'firebase/firestore';
import 'firebase/analytics';

const firebaseConfig = {
  // apiKey: "AIzaSyAuDzc_oQmQar8bMvnmPHppskVwTYDyzOs",
  // authDomain: "sinuous-studio-126510.firebaseapp.com",
  // databaseURL: "https://sinuous-studio-126510.firebaseio.com",
  // projectId: "sinuous-studio-126510",
  // storageBucket: "sinuous-studio-126510.appspot.com",
  // messagingSenderId: "23783309051",
  // appId: "1:23783309051:web:ef533ff5034090d2427a5e"

  apiKey: 'AIzaSyDq5XDBJmtloG02aIrwkw0QzPaFPwA1k-4',
  authDomain: 'ez-retro.firebaseapp.com',
  databaseURL: 'https://ez-retro.firebaseio.com',
  projectId: 'ez-retro',
  storageBucket: 'ez-retro.appspot.com',
  messagingSenderId: '193182095532',
  appId: '1:193182095532:web:c112612dbc3ca2ed266709',
  measurementId: 'G-MYWD5BCEMB'
  //
  // apiKey: "AIzaSyAY9EMMkem3j1xNIT4_aAMjzex0NQymXT4",
  // authDomain: "new-empty-8740a.firebaseapp.com",
  // databaseURL: "https://new-empty-8740a.firebaseio.com",
  // projectId: "new-empty-8740a",
  // storageBucket: "new-empty-8740a.appspot.com",
  // messagingSenderId: "303951898360",
  // appId: "1:303951898360:web:4b754bd5dd13cba3727d0d",
  // measurementId: "G-75HB7TBJMC"
};


// const firebaseDB = firebase.initializeApp(firebaseConfig);
const firebaseFirestore = firebase.initializeApp(firebaseConfig).firestore();

export const AUTH = firebase.auth();
export const ANALYTICS = firebase.analytics();
export const STORAGE = firebase.storage();
export const STORAGE_REF = STORAGE.ref();
export default firebaseFirestore;
